<template>
  <div class="container">
    <login-header :info="info"></login-header>
    <div class="content">
      <h3 align="center">{{ title }}</h3>
      <div class="" v-html="content">

      </div>
    </div>

    <div class="footer">
      {{ info.websiteNumber }}
    </div>
  </div>
</template>

<script>
import {agreementApi, webInfoApi} from '../../http/api/user.js'
import loginHeader from '../../components/loginHeader/index.vue'

export default {
  data() {
    return {
      content: '',
      title: '',
      info: {}
    }
  },
  components: {
    loginHeader
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      agreementApi({
        typeId: this.$route.query.id
      }).then(res => {
        console.log(res);
        this.content = res.conment
        this.title = res.title
      })
      webInfoApi().then(res => this.info = res)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  background-color: #ebebeb;

  .content {
    background-color: #fff;
    margin: 10px auto;
    padding: 10px;
    width: 60%;
    height: calc(100vh - 170px);
    overflow-y: scroll;

    h3 {
      color: #3b3b3b;
    }
  }

  .content::-webkit-scrollbar {
    display: none;
  }

  .footer {
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #3b3b3b;
    font-size: 14px;
  }

}


</style>